// extracted by mini-css-extract-plugin
module.exports = {"field-reference":"AppAddDeclarationCreditor_field-reference_3icAD","period--read-only":"AppAddDeclarationCreditor_period--read-only_33OtR"};